import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hasData: false
};

const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setFaqDataAvailable: (state, action) => {
      state.hasData = action.payload; 
    }
  }
});

export const { setFaqDataAvailable } = faqSlice.actions;
export default faqSlice.reducer;
